<template>
  <div class="vrification-box">
    <div class="title">{{ title }}</div>
    <div class="content">
      <div class="item phone">
        <div class="input-box">
          <label>账号</label>
          <input
            v-model="phone"
            type="text"
            placeholder="请输入账号"
            maxlength="11"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
          />
        </div>
      </div>
      <div v-if="loginType === 'code'" class="item code">
        <div class="input-box">
          <label>验证码</label>
          <input
            v-model="sendCode"
            type="text"
            placeholder="请输入验证码"
            maxlength="6"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
          />
        </div>
        <span
          class="code-btn"
          v-if="loginType === 'code'"
          @click="getCode"
          :class="content == '发送验证码' ? '' : 'active'"
          >{{ content }}</span
        >
      </div>
      <div v-else class="item password">
        <div class="input-box">
          <label>密码</label>
          <input
            v-model="password"
            :type="passwordType"
            placeholder="6-16位数字、字母"
            minlength="6"
            maxlength="16"
          />
        </div>
        <span
          class="eye-btn iconfont iconkejian"
          @click="openEye"
          :class="passwordType == 'password' ? '' : 'active'"
        ></span>
      </div>
      <div class="agreement">
        <span
          :class="
            active == true
              ? 'iconfont icontongyi icon'
              : 'iconfont icontongyi icon-active'
          "
          @click="getActive"
        ></span>
        <span>{{ agreementText }}</span>
        <span @click="toAgreement">用户协议</span>
      </div>
      <div class="btn-box">
        <loading-btn
          btnClass="btn"
          v-preventReClick
          @click="submit"
        >
          {{ btnName }}
        </loading-btn>
      </div>
    </div>
  </div>
</template>

<script>
import loadingBtn from "@/components/common/loadingBtn";
import validationMixin from "@/mixins/validationMixin";
import commonApi from "@/api/commonApi";
import userApi from "@/api/userApi";

export default {
  data() {
    return {
      userStatus: 0, // 后端状态：0 未注册 / 1 正常 / 2 已禁用
      content: "发送验证码", // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间
      canClick: true, //添加canClick
      active: true,
      phone: "",
      sendCode: "",
      password: "",
      passwordType: "password", // 密码状态切换
    };
  },
  mixins: [validationMixin],
  props: {
    loginType: {
      type: String,
      default: "code",
    },
    agreementText: String,
    title: String,
    btnName: String,
    smsType: String,
  },
  components: {
    loadingBtn
  },
  mounted() {
    this.$nextTick(() => {
      if (parseInt(this.smsType, 10) === 5) {
        this.phone = window.localStorage.getItem("loginPhone") || "";
      } else {
        this.phone = "";
      }
    });
  },
  methods: {
    openEye() {
      if (this.passwordType === "text") {
        this.passwordType = "password";
      } else {
        this.passwordType = "text";
      }
    },
    // 判断用户是否注册
    checkUser(callBack) {
      let validations = [
        {
          value: this.phone,
          method: "required",
          message: "请输入账号",
        },
        {
          value: this.phone,
          method: "rangelength",
          param: [8, 11],
          message: "请输入正确的账号",
        },
      ];

      if (this.check(validations)) {
        // 先判断用户状态
        userApi
          .checkUserStatus({
            phone: this.phone,
          })
          .then((res) => {
            this.userStatus = res.status;
            // 2026-10-22：后端 /user/check_user_status 的状态是三分，不是布尔：
            //   0 = 未注册（库里查不到该号码）
            //   1 = 正常（status === 1）
            //   2 = 已禁用（号码存在，但 UserInfo.status != 1）
            // 原实现把「非 1」一律当未注册，导致被管理员禁用的账号被提示
            // 「该号码未注册」，把用户引向「核对号码」这条错误的自救路径。
            if (this.userStatus === 1) {
              callBack();
            } else if (this.userStatus === 2) {
              this.$toast("该账号已被禁用，请联系管理员。");
            } else {
              this.$toast("该账号未注册，请仔细核对账号或联系管理员。");
            }
          });
      }
    },
    // 倒计时
    countDown() {
      if (!this.canClick) return;
      this.canClick = false;

      // 发送短信验证码
      let data = {
        phone: this.phone,
        sms_type: this.smsType,
      };
      commonApi.sendSmscode(data).then((res) => {
        console.log(res);
        this.$toast("验证码已发送，请在手机或登录邮箱查看。");
      });

      this.content = this.totalTime + "s后重新发送";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime < 1) {
          //当倒计时小于1时清除定时器
          window.clearInterval(clock);
          this.content = "发送验证码";
          this.totalTime = 60;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
    },
    getActive() {
      this.active = !this.active;
    },
    toAgreement() {
      this.$router.push({
        name: "page",
        query: {
          type: "agreement",
        },
      });
    },
    getCode() {
      let validations = [
        {
          value: this.phone,
          method: "required",
          message: "请输入账号",
        },
        {
          value: this.phone,
          method: "rangelength",
          param: [8, 11],
          message: "请输入正确的账号",
        },
      ];

      if (this.check(validations)) {
        // 获得手机验证码
        // 获得手机验证码之前先判定用户是否注册
        this.checkUser(() => {
          this.countDown();
        });
      }
    },
    submit() {
      // 分条件进行提交
      // 密码登录
      if (this.loginType === "password") {
        // 用户提交登录信息前先判定用户是否注册
        this.checkUser(() => {
          let validations = [
            {
              value: this.phone,
              method: "required",
              message: "请输入账号",
            },
            {
              value: this.phone,
              method: "rangelength",
              param: [8, 11],
              message: "请输入正确的账号",
            },
            {
              value: this.password,
              method: "required",
              message: "请输入密码（6-16位数字、字母）",
            },
            {
              value: this.password,
              method: "rangelength",
              param: [6, 16],
              message: "密码长度错误（6-16位数字、字母）",
            },
          ];

          if (this.check(validations)) {
            if (!/^[a-z0-9]{6,16}$/.test(this.password)) {
              this.$toast("密码格式错误（6-16位数字、字母）");
              return;
            }
            if (this.active === false) {
              this.$toast("请阅读并同意用户协议");
              return false;
            }
            this.$emit("callSubmit", this.phone, this.password);
          }
        });
      } else {
        // 验证码登录
        // 获得手机验证码的时候已经判断，这里不需要再判定用户是否注册
        let validations = [
          {
            value: this.phone,
            method: "required",
            message: "请输入账号",
          },
          {
            value: this.phone,
            method: "rangelength",
            param: [8, 11],
            message: "请输入正确的账号",
          },
          {
            value: this.sendCode,
            method: "required",
            message: "请输入验证码",
          },
          {
            value: this.sendCode,
            method: "rangelength",
            param: [6, 6],
            message: "验证码输入错误",
          },
        ];

        if (this.check(validations)) {
          if (this.active === false) {
            this.$toast("请阅读并同意用户协议");
            return false;
          }
          this.$emit("callSubmit", this.phone, this.sendCode);
        }
      }
    },
  },
};
</script>

<style lang="less">
.vrification-box {
  padding: 128px 30px 0 30px;
  .title {
    font-size: 30px;
    color: #333333;
  }
  .content {
    margin-top: 50px;
    width: 100%;
    .item {
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e4e4e4;
      font-size: 14px;

      label {
        width: 45px;
        display: inline-block;
        font-size: 14px;
        color: #333333;
        margin-right: 20px;
      }

      .code-btn {
        position: absolute;
        right: 30px;
        font-size: 14px;
        color: #8a3e2f;

        &.active {
          color: #999999;
        }
      }

      .eye-btn {
        font-size: 12px;
        color: #999999;
        display: block;
        padding: 10px;

        &.active {
          color: #8a3e2f;
        }
      }
    }
    .agreement {
      display: flex;
      margin-top: 16px;
      span {
        margin-right: 11px;
      }

      .icon {
        font-size: 14px;
        color: #8a3e2f;
        font-weight: 700;
      }
      .icon-active {
        font-size: 14px;
        color: #999999;
        font-weight: 700;
      }
      & span:nth-child(2) {
        font-size: 12px;
        color: #999999;
      }
      & span:nth-child(3) {
        font-size: 12px;
        color: #133e82;
      }
    }
    .btn-box {
      margin-top: 30px;
      .btn {
        width: 100%;
        height: 44px;
        text-align: center;
        line-height: 44px;
        background: #8a3e2f;
        font-size: 17px;
        color: #ffffff;
      }
    }
  }
}
</style>
